import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getWithdrawalInstructions } from './common';

const getFirmId = (_state: AdminState | ClientState, firmId: string) => firmId;
const getAccountWithdrawalDataId = (
    _state: AdminState | ClientState,
    _firmId: string,
    accountWithdrawalDataId: string
) => accountWithdrawalDataId;

export const getWithdrawalInstructionById = createSelector([ getWithdrawalInstructions, getFirmId, getAccountWithdrawalDataId ],
    (withdrawalInstructions, firmId, accountWithdrawalDataId): AccountWithdrawalDataRecord | [] => {
        const instructions = withdrawalInstructions[firmId];

        if (instructions) {
            return instructions[accountWithdrawalDataId];
        }

        return [];
    });

export const getWithdrawalInstructionsArray =
createSelector([ getWithdrawalInstructions, getFirmId ], (withdrawalInstructions, firmId): AccountWithdrawalDataRecord[] => {
    const instructions = withdrawalInstructions[firmId];

    if (instructions) {
        return Object.keys(instructions)
            .map(id => instructions[id])
            .filter(withdrawalInstruction => !withdrawalInstruction.IsDeleted);
    }

    return [];
});